import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var DisputeCtrl = function (fn, er, state, typeCall, token, ids) {

	var config = {
		//crossDomain: true,
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},

	};
	var data = {
		disputeType: state.checked,
		month: state.selectedMonthYear,
		orderBy: "+branchCode",
		typeCall: typeCall === undefined ? "X" : typeCall,
		page: 1
	};


	axios
		.post(ApiConfig.url.DISPUTE, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});


}

export { DisputeCtrl };